/* global require window console */

import Vue from "vue";
import locale from "locale";

import { trans } from "common/translate.js";
import { clickOutside } from "common/click-outside.js";

export default Vue.component("help-tooltip-toggle", {
  props: ["manuscriptName"],

  data() {
    return {
      expanded: false,
      collapseTimer: null,
      // Personal ID for this component to prevent clashing
      myId: Math.round(Math.random()*100000).toString(16),
      trans
    };
  },

  methods: {
    hide() {
      this.expanded = false;
    },

    setArrowPosition() {
      const windowWidth = window.innerWidth;
      let offset;

      this.$nextTick(() => {
        const rtl = locale === "ar_EG" || locale === "he_IL";


        if (rtl) {
          offset = -window.pageXOffset + 21;
        } else {
          const { width, left, } = this.$refs.tooltip.getBoundingClientRect();
          const rightEdge = left + width;
          offset = rightEdge - windowWidth + 21;
        }

        if (offset > 0) {
          this.$refs.arrow.style.transform = `translateX(${rtl ? -offset : offset}px)`;
          this.$refs.tooltip.style.transform = `translateX(${rtl ? offset : -offset}px)`;
        }
      });
    },

    clearArrowPosition() {
      this.$nextTick(() => {
        this.$refs.arrow.style.transform = "";
        this.$refs.tooltip.style.transform = "";
      });
    }
  },

  watch: {
    expanded(newVal) {
      if (newVal) {
        this.setArrowPosition();
      } else {
        this.clearArrowPosition();
      }
    },
  },

  directives: {
    clickOutside
  },

  template: require("./templates/help-tooltip-toggle.html")
});



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/help-tooltip-toggle.js